<template>
  <e-dialog
    dialog-title="开票申请信息"
    :center-dialog-visible="copyVisible"
    :popup-width="'400px'"
    button-tip="一键复制"
    @resetPopupData="resetPopupData"
    @submitPopupData="submitPopupData"
  >
    <div class="copy-style">
      <div class="head">
        <i class="el-icon-success success-style"></i>
        <span>开票信息提交成功</span>
      </div>
      <div class="body">
        <div class="text-line">
          <span>开票申请来源：</span>
          <span>{{ invoiceData.supplierCompany }}</span>
        </div>
        <div class="text-line">
          <span>发票抬头：</span> <span>{{ invoiceData.customer }}</span>
        </div>
        <div class="text-line">
          <span>购方税号：</span>
          <span>{{ invoiceData.identificationNumber }}</span>
        </div>
        <!-- <div class="text-line">
          <span>开票金额：</span>
          <span>
            <span v-if="invoiceData.invoiceMode == 1" class="red"
              >¥ {{ invoiceData.totalAmount }} 元</span
            >
            <span v-else>
              <span
                >货款金额:
                <span class="red">{{
                  invoiceData.productAmount
                    ? `¥ ${invoiceData.productAmount} 元`
                    : ''
                }}</span></span
              >
              <span
                v-if="invoiceData.invoiceMode === 2"
                style="margin-left: 10px"
                >运费金额:
                <span class="red">
                  {{
                    invoiceData.shipmentTotalAmount
                      ? `¥ ${invoiceData.shipmentTotalAmount} 元`
                      : '0 元'
                  }}
                </span>
              </span>
            </span></span
          >
        </div> -->
      </div>
      <div class="bottom">
        <div>点击链接登录百望平台补充流水单信息，进行开票：</div>
        <div></div>
          <a
            href="https://www.baiwang.com"
            >https://www.baiwang.com</a
          >
        </div>
      </div>
    </div>
  </e-dialog>
</template>

<script>
import object from 'element-resize-detector/src/detection-strategy/object';
import eDialog from '@/components/common/e-dialog.vue';

export default {
  name: 'ReasonDialog',
  components: { eDialog },
  props: {
    copyVisible: {
      type: Boolean,
      default: false,
    },
    invoiceData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
     
    };
  },
  mounted() {},
  methods: {
    resetPopupData() {
      this.$parent.copyVisible = false;
    },
    submitPopupData() {
      const content = `开票申请来源：${this.invoiceData.supplierCompany};发票抬头：${this.invoiceData.customer};购方税号：${this.invoiceData.identificationNumber};`;
      this.copyTextToClipboard(content);
      this.$message.success('发票信息复制成功');
    },
    copyTextToClipboard(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    },
  },
};
</script>

<style scoped lang="scss">
.copy-style {
  .head {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    .success-style {
      color: #67c23a;
      font-size: 20px;
      margin-right: 5px;
    }
  }
  .body {
    margin-bottom: 20px;
    .text-line {
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  .bottom {
    margin-bottom: 20px;
  }
}
</style>
